import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class WarningsEdit extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      name: '',
      warning_log_pending: null,
      warning_logs: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.approve = this.approve.bind(this);
    this.reprove = this.reprove.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      change[name] = value;
      this.setState(change);
    } else {
      var value = 0;
      change[name] = value;
      this.setState(change);
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/alerta/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/alertas');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            sector_id: responseJson.data.main.sector_id,
            premises: responseJson.data.main.premises,
            main: responseJson.data.main.main,
            main_active: responseJson.data.main.main_active,
            contract_active: responseJson.data.main.contract_active,
            main_color: responseJson.data.main.main_color,
            flight_report: responseJson.data.main.flight_report,
            flight_report_active: responseJson.data.main.flight_report_active,
            flight_report_color: responseJson.data.main.flight_report_color,
            schedule: responseJson.data.main.schedule,
            schedule_active: responseJson.data.main.schedule_active,
            schedule_color: responseJson.data.main.schedule_color,
            papers: responseJson.data.main.papers,
            papers_active: responseJson.data.main.papers_active,
            papers_color: responseJson.data.main.papers_color,
            warning_log_pending: responseJson.data.warning_log_pending,
            warning_logs: responseJson.data.warning_logs,
            sectors_list: responseJson.data.sectors_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (event) {
          self.handleAlert(event.message, event.status, 'open');
        } else {
          self.handleMessage();
        }
      });
    });
  }
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      warning_id: this.state.id,
      sector_id: this.state.sector_id,
      premises: this.state.premises,
      main: this.state.main,
      main_active: this.state.main_active,
      contract_active: this.state.contract_active,
      main_color: this.state.main_color,
      flight_report: this.state.flight_report,
      flight_report_active: this.state.flight_report_active,
      flight_report_color: this.state.flight_report_color,
      schedule: this.state.schedule,
      schedule_active: this.state.schedule_active,
      schedule_color: this.state.schedule_color,
      papers: this.state.papers,
      papers_active: this.state.papers_active,
      papers_color: this.state.papers_color,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alerta/revisao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  approve(id) {
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alerta/revisao/aprovar/' + id, { method: 'put', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  reprove(id) {
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alerta/revisao/reprovar/' + id, { method: 'put', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Alertas.EditarAlerta.titulo} - {this.state.name}</h3>
      <Link to="/alertas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        {/* {this.state.main === 1 &&
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.EscalaDeMissaoAtivo}:</label>
                <br/>
                <Toggle
                  checked={this.state.main_active}
                  onChange={this.handleToggleChange.bind(this, 'main_active')}
                  aria-label=''
                  name="main_active"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.EscalaDeMissaoCor}:</label>
                <Select
                  className=""
                  name="flight_report_color"
                  value={this.state.main_color}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'main_color')}
                  options={[
                    {value: 'red', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Vermelho},
                    {value: 'orange', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Laranja},
                    {value: 'green', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Verde},
                  ]}
                />
              </div>
            </div>
          </div>
        } */}
        {this.state.flight_report === 1 &&
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.RelatorioDeVooAtivo}:</label>
                <br/>
                <Toggle
                  checked={this.state.flight_report_active}
                  onChange={this.handleToggleChange.bind(this, 'flight_report_active')}
                  aria-label=''
                  name="flight_report_active"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.RelatorioDeVooCor}:</label>
                <Select
                  className=""
                  name="flight_report_color"
                  value={this.state.flight_report_color}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'flight_report_color')}
                  options={[
                    {value: 'red', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Vermelho},
                    {value: 'orange', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Laranja},
                    {value: 'green', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Verde},
                  ]}
                />
              </div>
            </div>
          </div>
        }
        {this.state.schedule === 1 &&
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.EscalaDiariaAtivo}:</label>
                <br/>
                <Toggle
                  checked={this.state.schedule_active}
                  onChange={this.handleToggleChange.bind(this, 'schedule_active')}
                  aria-label=''
                  name="schedule_active"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.EscalaDiariaCor}:</label>
                <Select
                  className=""
                  name="schedule_color"
                  value={this.state.schedule_color}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'schedule_color')}
                  options={[
                    {value: 'red', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Vermelho},
                    {value: 'orange', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Laranja},
                    {value: 'green', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Verde},
                  ]}
                />
              </div>
            </div>
          </div>
        }
        {/* {this.state.papers === 1 &&
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.PapeletasAtivo}:</label>
                <br/>
                <Toggle
                  checked={this.state.papers_active}
                  onChange={this.handleToggleChange.bind(this, 'papers_active')}
                  aria-label=''
                  name="papers_active"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Alertas.EditarAlerta.formulario.PapeletasCor}:</label>
                <Select
                  className=""
                  name="papers_color"
                  value={this.state.papers_color}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'papers_color')}
                  options={[
                    {value: 'red', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Vermelho},
                    {value: 'orange', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Laranja},
                    {value: 'green', 'label': this.locale.Alertas.EditarAlerta.formulario.opcoesCor.Verde},
                  ]}
                />
              </div>
            </div>
          </div>
        } */}
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Alertas.EditarAlerta.formulario.AreaResponsavel}:</label>
              <Select
                className="form-field-name"
                name="sector_id"
                value={this.state.sector_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'sector_id')}
                options={this.state.sectors_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Alertas.EditarAlerta.formulario.Premissas}:</label>
              <input type="textarea" name="premises" className="form-control" placeholder="" value={this.state.premises} onChange={this.handleChange.bind(this, 'premises')} />
            </div>
          </div>
        </div>
        {/* <div className="row">
          <div  className="col-md-6">
            <div className="form-group">
              <label>Alerta considera contrato?:</label>
              <br/>
              <Toggle
                checked={this.state.contract_active}
                onChange={this.handleToggleChange.bind(this, 'contract_active')}
                aria-label=''
                name="contract_active"
              />
            </div>
          </div>
        </div> */}
        <hr/>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
          </div>
        </div>
      </form>
      <hr/>
      <h4>{this.locale.Alertas.EditarAlerta.tituloRevisoesPendentes}</h4>
      <div className="table-responsive">
        {this.state.warning_log_pending ?
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.AreaResponsavel}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.Premissas}</th>
              {/* <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.EscalaDeMissaoAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.EscalaDeMissaoCor}</th> */}
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.RelatorioDeVooAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.RelatorioDeVooCor}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.EscalaDiariaAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.EscalaDiariaCor}</th>
              {/* <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.PapeletasAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.PapeletasCor}</th> */}
              <th>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.Autor}</th>
              <th style={{width: 100}}>{this.locale.Alertas.EditarAlerta.tabelaRevisoesPendentes.Acoes}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{this.state.warning_log_pending.sector.name}</td>
              <td>{this.state.warning_log_pending.premises}</td>
              {/* <td>{this.state.warning_log_pending.main_active_str}</td>
              <td>{this.state.warning_log_pending.main_color_str}</td> */}
              <td>{this.state.warning_log_pending.flight_report_active_str}</td>
              <td>{this.state.warning_log_pending.flight_report_color_str}</td>
              <td>{this.state.warning_log_pending.schedule_active_str}</td>
              <td>{this.state.warning_log_pending.schedule_color_str}</td>
              {/* <td>{this.state.warning_log_pending.papers_active_str}</td>
              <td>{this.state.warning_log_pending.papers_color_str}</td> */}
              <td>{this.state.warning_log_pending.sign_1}</td>
              <td>
                <button className="btn btn-sm btn-success" onClick={() => this.approve(this.state.warning_log_pending.id)}><i className="fa fa-fw fa-check"></i></button>
                <button className="btn btn-sm btn-danger" onClick={() => this.reprove(this.state.warning_log_pending.id)}><i className="fa fa-fw fa-close"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
        :
        this.locale.Alertas.EditarAlerta.naoHaRevisoesPendentes
      }
      </div>
      <hr/>
      <h4>{this.locale.Alertas.EditarAlerta.tituloLogDeRevisoes}</h4>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Situacao}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Data}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.AreaResponsavel}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Premissas}</th>
              {/* <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.EscalaDeMissaoAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.EscalaDemissaoCor}</th> */}
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.RelatorioDeVooAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.RelatorioDeVooCor}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.EscalaDiariaAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.EscalaDiariaCor}</th>
              {/* <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.PapeletasAtivo}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.PapeletasCor}</th> */}
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Autor}</th>
              <th>{this.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Aprovacao}</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(self.state.warning_logs).map(function(k) {
              var srl = self.state.warning_logs[k];
              return (
                <tr>
                  <td>
                    { srl.status === 'initial' && <span className="label label-primary">{self.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Inicial}</span> }
                    { srl.status === 'approved' && <span className="label label-success">{self.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Aprovada}</span> }
                    { srl.status === 'reproved' && <span className="label label-danger">{self.locale.Alertas.EditarAlerta.tabelaLogDeRevisoes.Reprovada}</span> }
                  </td>
                  <td>{srl.created_at_str}</td>
                  <td>{srl.sector !== null ? srl.sector.name : ''}</td>
                  <td>{srl.premises}</td>
                  {/* <td>{srl.main_active_str}</td>
                  <td>{srl.main_color_str}</td> */}
                  <td>{srl.flight_report_active_str}</td>
                  <td>{srl.flight_report_color_str}</td>
                  <td>{srl.schedule_active_str}</td>
                  <td>{srl.schedule_color_str}</td>
                  {/* <td>{srl.papers_active_str}</td>
                  <td>{srl.papers_color_str}</td> */}
                  <td>{srl.sign_1}</td>
                  <td>{srl.sign_2}</td>
                </tr>
                );
            })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default WarningsEdit;



// WEBPACK FOOTER //
// ./src/Components/Warnings/WarningsEdit.js